import { render, staticRenderFns } from "./ScorecardSection.vue?vue&type=template&id=6ff8fc54&scoped=true"
import script from "./ScorecardSection.vue?vue&type=script&lang=js"
export * from "./ScorecardSection.vue?vue&type=script&lang=js"
import style0 from "./ScorecardSection.vue?vue&type=style&index=0&id=6ff8fc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8fc54",
  null
  
)

export default component.exports